import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation AddRecordOccupants(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $spaceRecordId: ID!
    $employeeIds: [ID!]!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                addOccupants(
                  spaceRecordId: $spaceRecordId
                  employeeIds: $employeeIds
                )
              }
            }
          }
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.AddRecordOccupantsMutation,
  undefined,
  graphql.schema.AddRecordOccupantsMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
